import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_compliance_jun_2026~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_compliance_jun_2026/f/__b'),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_compliance_jun_2026~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_compliance_jun_2026/walking-f/__b'),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_compliance_jun_2026~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_compliance_jun_2026/tai-chi-walking-f-v2/__b'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_compliance_jun_2026~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_compliance_jun_2026/tai-chi-walking-f-v2-al/__b'),
			},
		},
	},
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_compliance_jun_2026~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_compliance_jun_2026/f/__c'),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_compliance_jun_2026~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_compliance_jun_2026/walking-f/__c'),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_compliance_jun_2026~2
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_compliance_jun_2026/tai-chi-walking-f-v2/__c'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_compliance_jun_2026~2
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_compliance_jun_2026/tai-chi-walking-f-v2-al/__c'),
			},
		},
	},
]

export default config
